export default __webpack_public_path__ + "static/media/event_close.2990fbbe.svg";